import { Injectable } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidationsService {
  setMaxLength(length: number): Validators {
    return Validators.maxLength(length);
  }

  setMinLength(length: number): Validators {
    return Validators.minLength(length);
  }

  setRequired(): Validators {
    return Validators.required;
  }

  setEmail(): Validators {
    return Validators.email;
  }

  setEmailPattern(): Validators {
    return Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$');
  }

  convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    const ctrl = absCtrl as FormControl;
    return ctrl;
  }

  passwordConfirming(c: AbstractControl): { invalid: boolean } {
    if (c.get('password')?.value !== c.get('confirmPassword')?.value) {
      return { invalid: true };
    }
    return { invalid: false };
  }
}
